import { RemotefileService } from "@buf/brevdev_devplane.connectrpc_es/devplaneapi/v1/remotefile_connect";
import { createConnectClient } from "../../connect";

const remotefileClient = createConnectClient(RemotefileService);

export interface ValidateRemoteFileResult {
  public: boolean;
  fileName: string;
  errorMessage: string;
}

export async function validateRemoteFile(
  fileUrl: string,
): Promise<ValidateRemoteFileResult> {
  const response = await remotefileClient.validateFile({ fileUrl });

  return {
    public: response.isValid,
    fileName: response.fileName,
    errorMessage: response.errorMessage,
  };
}
